var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 243,
    viewBox: "0 0 242 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41645 90.2491C21.7675 25.4943 88.054 -13.0074 152.472 4.25327C216.889 21.5139 255.044 88.0006 237.693 152.755C220.342 217.51 154.056 256.012 89.638 238.751C25.2204 221.491 -12.9346 155.004 4.41645 90.2491ZM182.677 138.014C191.844 103.803 171.686 68.6762 137.653 59.557C103.62 50.4379 68.5991 70.7791 59.4322 104.991C50.2653 139.202 70.4234 174.328 104.457 183.447C138.49 192.567 173.51 172.225 182.677 138.014Z",
    fill: "url(#paint0_linear_10_423)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_423",
    x1: 89.638,
    y1: 238.751,
    x2: 152.472,
    y2: 4.25327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A74FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedShape);
export default __webpack_public_path__ + "static/media/rounded-shape.553aa2d69b198574f85bcd9a3bf9b2d3.svg";
export { ForwardRef as ReactComponent };